module.exports = __webpack_public_path__ + "img/giving3.06d811f7.png";